import {
  CATEGORIES_ROUTE,
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  ORDER_ROUTE,
  PRODUCT_ROUTE,
  RETURN_ORDER_ROUTE,
} from "../paths";

export const STAFF_PERMISSION_ROUTES: string[] = [
  DASHBOARD_ROUTE,
  ORDER_ROUTE,
  RETURN_ORDER_ROUTE,
  PRODUCT_ROUTE,
  CATEGORIES_ROUTE,
  LOGIN_ROUTE,
];
